import { Link } from "react-router-dom";
import { ChevronRight, Home, Info } from "lucide-react";

export function Breadcrumbs({ items = [] }) {
  return (
    <nav data-testid="breadcrumbs" className="flex items-center flex-wrap gap-1 text-sm text-muted-foreground">
      <Link to="/" className="hover:text-gold flex items-center"><Home size={14} /></Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight size={14} />
          {it.to ? <Link to={it.to} className="hover:text-gold">{it.label}</Link> : <span className="text-navy font-medium">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <p className="text-xs uppercase tracking-[0.2em] text-gold font-bold mb-2">{eyebrow}</p>}
        <h2 className="font-display text-3xl md:text-4xl font-bold text-navy tracking-tight">{title}</h2>
        {subtitle && <p className="mt-2 text-muted-foreground max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function DataNote({ status }) {
  return (
    <div data-testid="data-note" className="flex items-start gap-2 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-900">
      <Info size={16} className="mt-0.5 shrink-0" />
      <span>This is <strong>sample/unverified data</strong>{status ? ` (${status})` : ""}. Figures such as fees, placements and rankings must be verified with the official institute before making any decision.</span>
    </div>
  );
}

export function Loader() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="w-10 h-10 border-4 border-gold/30 border-t-gold rounded-full animate-spin" />
    </div>
  );
}
